<template>
  <div class="seasons">
    <button class="secondary" @click="$router.push('/shows')">back</button>
    <h1>{{name}}</h1>

    <table>
      <thead>
        <th>Name</th>
      </thead>
      <tbody>
        <tr v-for="season in seasons" :key="season.id">
          <td @click="$router.push('/shows/' + $route.params.name + '/' + season.name)">{{season.name}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import config from '../config';

const token =  localStorage.getItem('token');

export default {
  name: 'Seasons',
  data() {
    return {
      seasons: [],
      name: ''
    }
  },
  methods: {
    getSeasons() {
      this.name = this.$route.params.name;

      this.axios.get(config.api + '/seasons/' + this.name, {
        headers: {
          'authorization': token
        }
      })
        .then(result => {
          this.seasons = result.data;

          if (this.seasons.length === 1)
            this.$router.push('/shows/' + this.$route.params.name + '/' + this.seasons[0].name);
        })
    }
  },
  created() {
    this.getSeasons();
  }
}
</script>

<style scoped>

button.secondary {
  margin: 20px 0 -10px 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Seasons.vue